import { useCallback, useContext, useEffect } from 'react';
import { GeneralizationContext } from '../contexts/GeneralizationContext';

const useFullscreen = () => {
  const { setIsFullScreen } = useContext(GeneralizationContext);

  const handleEscapeKey = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsFullScreen(false);
      }
    },
    [setIsFullScreen],
  );

  const toggleFullScreen = useCallback(() => {
    setIsFullScreen((prev) => !prev);
  }, [setIsFullScreen]);

  useEffect(() => {
    document.addEventListener('fullscreenchange', toggleFullScreen);
    document.addEventListener('keydown', handleEscapeKey);

    return () => {
      document.removeEventListener('fullscreenchange', toggleFullScreen);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [handleEscapeKey, toggleFullScreen]);

  return {
    toggleFullScreen,
  };
};

export default useFullscreen;
